import { themeConfig } from '../theme/theme-config'
import type { SettingsState } from './types'

// --------------------------------------------------------------------------------------------- //

export const SETTINGS_STORAGE_KEY = 'app-settings'

export const defaultSettings: SettingsState = {
  colorScheme: themeConfig.defaultMode,
  compactLayout: false,
  contrast: 'default',
  direction: themeConfig.direction,
  fontFamily: themeConfig.fontFamily.primary,
  fontSize: 16,
  navColor: 'integrate',
  navLayout: 'vertical',
  primaryColor: 'preset3'
}
